import { Card, styled } from '@mui/material';

const ModalCard = styled(Card)({
  backgroundColor: 'rgb(27 67 50 / .14)',
  padding: '20px',
  boxShadow: 'none',
});

export default ModalCard;
